enum breakpoints {
  xs = '319px',
  sm = '374px',
  lsm = '480px',
  md = '800px',
  lg = '1024px',
}

export default breakpoints;
